// extracted by mini-css-extract-plugin
export default {"dropdownItem":"ReceiptsList_dropdownItem__Mrklq"};